import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { array, object, func } from 'prop-types'
import RadioButton from '@taglivros/oef_componentes/build/components/radioButton'
import RadioGroup from '@taglivros/oef_componentes/build/components/radioGroup'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

import CardEnderecoEntrega from '../../../containers/Modalidade/components/CardEnderecoEntrega/CardEnderecoEntrega'
import CardAdicionar from '../../../components/CardAdicionar'
import EnderecoForm from '../../../components/EnderecoForm/EnderecoForm'
import ModalEscolherEndereco from './ModalEscolherEndereco'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { ID_CADASTRO_NOVO_ENDERECO, TITULO_CADASTRAR_NOVO_ENDERECO, TITULO_ENDERECOS_CADASTRADOS } from '../constantsFluxosPagamento'
import { isEmptyObject } from '../../../utils/helpers/helpers'

const MenuEscolhaEntrega = styled.div`
  margin-top: 30px;

  #menu-endereco {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;

    & > div {
      @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
        width: calc((100%/2) - 4%);
      }

      & > div, .children {
        width: 100%;
      }

      .children > div > div > div {
        box-shadow: 0px 0px 0px 2px ${( { tema } ) => tema};

        > h6 {
          color: ${( { tema } ) => tema};
        }
      }
    }

    .radioLabel {
      margin-bottom: 20px;

      > div {
        border-color: ${( { tema } ) => tema} !important;
        &::after {
          background: ${( { tema } ) => tema} !important;
        }
      }
    }
  }

  .card__endereco__entrega {
    & .card {
      opacity: ${( { isNovoEndereco } ) => isNovoEndereco ? '.3' : '1'};
      transition: .3s all ease-in-out;
    }

    & span {
      ${StyleGuide.boldFonte}
      color: ${( { tema } ) => tema};
      cursor: pointer;
      text-decoration: underline;
    }
  }
`


const EscolhaEntrega = ( { enderecoVigente, enderecos, etapaAtual, setarNovoEndereco } ) => {
  const {
    setarDadosEtapas,
    temaFluxo,
    proximaEtapaAutocomplete,
  } = useFluxosPagamento()
  const [ idEnderecoSelecionado, setIdEnderecoSelecionado ] = useState()
  const [ novoEndereco, setNovoEndereco ] = useState( {} )
  const [ openFormulario, setOpenFormulario ] = useState( false )
  const [ verMaisEndereco, setVerMaisEndereco ] = useState( false )
  const [ enderecoSelecionado, setEnderecoSelecionado ] = useState( {} )

  useEffect( () => {
    if ( enderecoVigente ) {
      setIdEnderecoSelecionado( enderecoVigente.id )
      setEnderecoSelecionado( enderecoVigente )
    }
  }, [ enderecoVigente ] )

  useEffect( () => {
    let selecaoEndereco = enderecos.find( endereco => endereco.id === idEnderecoSelecionado )
    if ( idEnderecoSelecionado ) {
      const enderecosMesmoId = enderecos.filter( endereco => endereco.id === idEnderecoSelecionado )
      selecaoEndereco = enderecosMesmoId[ enderecosMesmoId.length - 1 ]
      if ( idEnderecoSelecionado === ID_CADASTRO_NOVO_ENDERECO && !isEmptyObject( novoEndereco ) ) {
        selecaoEndereco = novoEndereco
      } else if ( idEnderecoSelecionado !== ID_CADASTRO_NOVO_ENDERECO ) {
        setOpenFormulario( false )
      }

      setarDadosEtapas( selecaoEndereco, etapaAtual.identificador )
      proximaEtapaAutocomplete( { etapaAtual } )
    }
  }, [ enderecoVigente, idEnderecoSelecionado, novoEndereco ] )

  const salvarEnderecoSelecionado = id => {
    if ( id.optionChecked && id.optionChecked === ID_CADASTRO_NOVO_ENDERECO ) {
      setOpenFormulario( true )
    }

    setIdEnderecoSelecionado( Number( id.optionChecked ) || id.optionChecked || id )
  }

  return (
    <div>
      { verMaisEndereco ?
        <ModalEscolherEndereco
          closeModal={ () => setVerMaisEndereco( false ) }
          enderecoSelecionado={ enderecoSelecionado }
          enderecoVigente={ enderecoVigente }
          enderecos={ enderecos }
          setEnderecoSelecionado={ setEnderecoSelecionado }
          setIdEnderecoSelecionado={ setIdEnderecoSelecionado }
          showModal={ verMaisEndereco }
          tema={ temaFluxo }
        /> : null}

      <MenuEscolhaEntrega
        isNovoEndereco={ idEnderecoSelecionado === ID_CADASTRO_NOVO_ENDERECO }
        tema={ temaFluxo }
      >
        { !isEmptyObject( enderecoVigente ) && idEnderecoSelecionado ?
          <RadioGroup
            defaultOption={ idEnderecoSelecionado }
            group="menu-endereco"
            itemsDirection={ StyleGuide.isMobile() ? 'column' : 'row' }
            itemsPadding="0px 0px 20px 0px"
            listDirection={ StyleGuide.isMobile() ? 'column' : 'row' }
            onChange={ salvarEnderecoSelecionado }
          >
            <RadioButton
              group="menu-endereco"
              id="endereco-vigente"
              label={ TITULO_ENDERECOS_CADASTRADOS }
              value={ enderecoSelecionado !== ID_CADASTRO_NOVO_ENDERECO && enderecoSelecionado.id }
            >
              <div className="card__endereco__entrega">
                <CardEnderecoEntrega
                  ativo={ enderecoSelecionado !== ID_CADASTRO_NOVO_ENDERECO }
                  botaoVerMais={ false }
                  endereco={ enderecoSelecionado !== ID_CADASTRO_NOVO_ENDERECO && enderecoSelecionado }
                  hasHover
                  isEnderecoVigente={ enderecoSelecionado.id === enderecoVigente.id }
                  onClickCard={ () => salvarEnderecoSelecionado( enderecoSelecionado !== ID_CADASTRO_NOVO_ENDERECO && enderecoSelecionado.id ) }
                />
              </div>
            </RadioButton>

            <RadioButton
              group="menu-endereco"
              id={ ID_CADASTRO_NOVO_ENDERECO }
              label={ TITULO_CADASTRAR_NOVO_ENDERECO }
              value={ ID_CADASTRO_NOVO_ENDERECO }
            >
              <div>
                { openFormulario ?
                  <EnderecoForm
                    onConfirmar={ ( enderecoRetornado ) => {
                      setarNovoEndereco( enderecoRetornado )
                      setNovoEndereco( { ...novoEndereco, ...enderecoRetornado } )
                    } }
                    tema={ temaFluxo }
                  /> :
                  <CardAdicionar
                    margin={ StyleGuide.isMobile() ? '0' : '0 0 25px' }
                    onClick={ () => {
                      salvarEnderecoSelecionado( ID_CADASTRO_NOVO_ENDERECO )
                      setOpenFormulario( true )
                    } }
                    titulo={ TITULO_CADASTRAR_NOVO_ENDERECO }
                  />}
              </div>
            </RadioButton>
          </RadioGroup> : null}
      </MenuEscolhaEntrega>
    </div>
  )
}

EscolhaEntrega.propTypes = {
  'enderecoVigente': object.isRequired,
  'enderecos': array.isRequired,
  'etapaAtual': object.isRequired,
  'setarNovoEndereco': func.isRequired,
}

export default EscolhaEntrega
